import {
  useState,
  useEffect,
  useRef,
  useContext,
} from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons/faAngleUp';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons/faAngleDown';

import Breadcrumbs from '../Breadcrumbs';
import InvestorRelationsComponent from '../SEO_pages/InvestorRelations';

import { SEO_IR_BREADCRUMBS } from '../../data/directory/constants';

import useSizes from '../../hooks/sizes';

import Styles from './styles.module.scss';
import withMetatag from '../../decorators/metadataDecorators/metatagsTitleDecorator';
import piwikContext from '../../services/piwikContext';

const cx = classNames.bind(Styles);

const InvestorRelations = () => {
  const descRef = useRef();
  const [hasShowMore, setHasShowMore] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);
  const { piwikEnabled } = useContext(piwikContext);
  const { width } = useSizes();
  const { searchBarActive } = useSelector((state) => state.searchReducers);

  useEffect(() => {
    if (width < 400 && descRef.current) {
      return setHasShowMore(descRef.current.scrollHeight > 70);
    }
    setHasShowMore(false);
  }, [width]);

  const toggleExpand = () => {
    setIsShowMore(!isShowMore);
  };

  return (
    <div className={cx(Styles.investor_relations, searchBarActive && Styles.blurred)}>
      <Breadcrumbs items={SEO_IR_BREADCRUMBS} />
      <div className={Styles.header_title}>
        Investor Relations
      </div>
      <div className={cx('header_desc', { expand: isShowMore, show_more: hasShowMore })} ref={descRef}>

        All the latest company and investor relations documents and presentations, earnings calls,
        reports and financial statements for top companies.&nbsp;
        <a
          href="https://www.cityfalcon.ai/features/investor-relations"
          target="_blank"
          rel="noreferrer noopener"
        >
          Learn more.
        </a>
      </div>
      {hasShowMore && (
        <div className={Styles.description_show} onClick={toggleExpand}>
          Show&nbsp;
          {isShowMore ? 'Less' : 'More'}
          <FontAwesomeIcon className="img mob" icon={isShowMore ? faAngleUp : faAngleDown} />
        </div>
      )}
      <InvestorRelationsComponent
        isMainPage
        piwikEnabled={piwikEnabled}
      />
    </div>
  );
};

export default withMetatag(InvestorRelations, 'directory/investor-relations');
